import React, { useState } from 'react';
import { Box, IconButton, InputAdornment, TextField } from "@material-ui/core"
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import { useStyles } from '../styles/index.style';

const TableActions = ({
   onFilterChange
}) => {
   const classes = useStyles();
   const [searchInput, setSearchInput] = useState('');

   const onInputKeyDown = (event) => {
      if (event.key === 'Enter') {
         onFilterChange({searchTerm: searchInput})
      }
   }
   
   return (
      <Box display="flex" pl="30px" pr="20px" flexWrap="wrap">
         <div style={{display: "flex", marginBottom: "15px"}}>
         <TextField
            id="search-field"
            placeholder="Start Typing"
            className={classes.searchInput}
            onKeyDown={onInputKeyDown}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            InputProps={{
               endAdornment: (
                  <InputAdornment position="end">
                     <IconButton style={{ padding: 3 }} onClick={() => {}}>
                        <SearchIcon style={{ color: 'grey' }} />
                     </IconButton>
                  </InputAdornment>
               ),
            }}
            variant="standard"
         />
      </div>
   </Box>
   )
}

TableActions.propTypes = {
   onFilterChange: PropTypes.func,
};

TableActions.defaultProps = {
   onFilterChange: null,
};

export default TableActions